const BaseUrl = "./case";

export const VCCP_DASHBOARD_COUNT = `${BaseUrl}/metricDashboard`;
export const SUPPORT_TYPE_COUNT = `${BaseUrl}/supportTypeCount`;
export const CASESUPPORT_CREATED_CLOSED = `${BaseUrl}/caseSupportCreatedVSClosed`;
